import { BrandingProps, useBranding } from 'hooks/useBranding';
import Page from 'layouts/Page';
import WaiverPage from 'layouts/WaiverPage';
import { organizationApi } from 'lib/api/organizationApi';
import router, { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { UserSettings } from 'types/userSettings';
import WaiverConfirmation from './WaiverConfirmation';
import WaiverContent from './WaiverContent';
import { i18n } from 'lib/i18n';
import { useLogin } from 'hooks/useLogin';
function Waiver() {
	const { query } = useRouter();
	const { a: authToken } = query;
	const [formTitle, setFormTitle] = useState<string>('');
	const [orgQuestionairreId, setOrgQuestionairreId] = useState<number>();
	const [showContent, setShowContent] = useState(true);
	const [selectedMember, setSelectedMember] = useState<UserSettings | null>();
	const [isLoading, setLoading] = useState<boolean>(true);
	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
	const { setBranding } = useBranding();

	const { isLoggedInV2 } = useLogin();

	useEffect(() => {
		if (!isLoggedIn) {
			setShowContent(true);
		}
	}, [isLoggedInV2]);

	useEffect(() => {
		const organizationId = Number(router?.router?.query.organizationId);
		if (organizationId) {
			(async () => {
				const header = {
					authorization: `Bearer ${(authToken as string) ?? ''}`,
				};

				const { data: organizationData } = await organizationApi.getOrganizationById(
					organizationId,
					!isLoggedIn ? header : undefined
				);
				if (organizationData?.questionnaireId) {
					setOrgQuestionairreId(organizationData.questionnaireId);
					setBranding((organizationData.brandings as unknown) as BrandingProps[]);
				}
				setLoading(false);
			})();
		} else {
			setLoading(false);
		}
	}, [router.router?.query, isLoggedIn]); // eslint-disable-line react-hooks/exhaustive-deps

	const confirmed = (addAnotherWaiver: boolean) => {
		if (addAnotherWaiver) {
			setShowContent(true);
		} else {
			router.push('/user/profile');
		}
	};

	const waiverFilled = (selectedMember?: UserSettings | null) => {
		setShowContent(false);
		setSelectedMember(selectedMember);
	};

	const handleSetFormTitle = (title: string) => {
		setFormTitle(title);
	};

	const handleOnLogIn = () => {
		setIsLoggedIn(true);
	};

	if (isLoading) {
		return i18n.loading;
	}
	return (
		<Page showHeroBg>
			<WaiverPage>
				{showContent ? (
					<WaiverContent
						waiverFilled={waiverFilled}
						onSetTitle={handleSetFormTitle}
						orgQuestionairreId={orgQuestionairreId}
						formTitle={formTitle}
						onLogIn={handleOnLogIn}
					/>
				) : (
					<WaiverConfirmation confirmed={confirmed} selectedMember={selectedMember} waiverTitle={formTitle} />
				)}
			</WaiverPage>
		</Page>
	);
}

export default Waiver;
